import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt, FaUsers, FaTag } from "react-icons/fa";
import "../Styles/Home.scss";
import BG from "../Image/bg1.png";
import img1 from "../Image/img26.JPG";
import img2 from "../Image/img30.JPG";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import doubleRoom from "../Image/img40.JPG";
import tripleRoom from "../Image/img39.JPG";
import quadRoom from "../Image/quadroom.webp";
import Rest from "../Image/img19.JPG";
import Rec from "../Image/img18.JPG";
import { Link } from "react-router-dom";

const cardsData = [
  {
    id: 1,
    icon: <FaMapMarkerAlt />,
    text: "Located in the best seaside area",
    bgColor: "#8c7864",
    textColor: "#faf8f5",
  },
  {
    id: 2,
    icon: <FaUsers />,
    text: "Friendly and welcoming staff",
    bgColor: "#a3968d",
    textColor: "#faf8f5",
  },
  {
    id: 3,
    icon: <FaTag />,
    text: "Best prices and great offers",
    bgColor: "#4d403a",
    textColor: "#faf8f5",
  },
];
const roomsData = [
  {
    type: "Double Room",
    description: "Cozy and elegant room for 2 guests.",
    image: doubleRoom,
  },
  {
    type: "Triple Room",
    description: "Spacious room suitable for 3 guests.",
    image: tripleRoom,
  },
  {
    type: "Quadruple Room",
    description: "Perfect for families or groups of 4.",
    image: quadRoom,
  },
];
const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setCardsPerView(3);
        setCurrentIndex(0); // reset on desktop
      } else if (window.innerWidth >= 768) {
        setCardsPerView(2);
      } else {
        setCardsPerView(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxIndex = roomsData.length - cardsPerView;

  const next = () => {
    setCurrentIndex((prev) => (prev < maxIndex ? prev + 1 : prev));
  };

  const prev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };
  const touchStartX = React.useRef(0);
  const touchEndX = React.useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const swipeDistance = touchStartX.current - touchEndX.current;

    if (Math.abs(swipeDistance) > 50) {
      setTappedIndex(null); // close overlay on swipe
      swipeDistance > 0 ? next() : prev();
    }
  };

  const [tappedIndex, setTappedIndex] = useState(null);

  const handleCardTap = (index) => {
    if (cardsPerView === 1 || cardsPerView === 2) {
      setTappedIndex((prev) => (prev === index ? null : index));
    }
  };

  // -------------------- Cards Auto-Rotation --------------------
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % cardsData.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div>
      {/* -------------------- HERO -------------------- */}
      {/* <div className="background-container">
        <div className="desc">
          <div className="stars">★★★★</div> 
          <h2>HOTEL</h2>
          <h1>KURTI</h1>
          <h3>Your Getaway is Calling.</h3>
          <Link to="/contact">
            <button onClick={scrollToTop}>Get in Touch</button>
          </Link>
        </div>
        <div className="img">
          <img src={BG} alt="hotel desc" />
        </div>
      </div> */}
      <div className="background-container">
        <img src={BG} alt="Hotel Kurti" className="hero-bg" />

        <div className="overlay"></div>

        <div className="desc">
          <div className="stars">★★★★</div>
          <h2>HOTEL</h2>
          <h1>Kurti</h1>
          <h3>Your Getaway is Calling.</h3>
          <p>
            Create lasting memories in a welcoming atmosphere designed for your
            comfort.
          </p>

          <Link to="/contact">
            <button onClick={scrollToTop}>Get in Touch</button>
          </Link>
        </div>
      </div>
      {/* -------------------- INFO CARDS -------------------- */}
      <section className="cards-container">
        {cardsData.map((card, index) => (
          <div
            key={card.id}
            className={`card ${activeIndex === index ? "active" : "inactive"}`}
            style={{ backgroundColor: card.bgColor, color: card.textColor }}
          >
            <div className="icon">{card.icon}</div>
            <p>{card.text}</p>
          </div>
        ))}
      </section>

      {/* -------------------- ABOUT -------------------- */}
      <div className="about-container">
        <div className="abt-txt">
          <h1>
            THOUGHTFUL STAYS,
            <br /> BEAUTIFUL MOMENTS.
          </h1>
          <p>
            Every stay at our hotel is designed with care, combining comfort,
            style, and attention to detail. From relaxing rooms to welcoming
            spaces, we create beautiful moments you’ll remember. Our team
            ensures that every need is met, so your visit is effortless and
            truly enjoyable. Experience a place where thoughtful service and
            serene surroundings come together to make every stay special.
          </p>
          <Link to="/about">
            <button className="about-btn" onClick={scrollToTop}>
              About Us
            </button>
          </Link>
        </div>
        <div className="abt-img">
          <img src={img1} className="img1" alt="about section" />
          <img src={img2} className="img2" alt="about section" />
        </div>
      </div>
      <section className="rooms-section">
        <h1>OUR ROOMS</h1>

        <div className="rooms-container">
          {cardsPerView < 3 && (
            <FaArrowLeft className="arrow left" onClick={prev} />
          )}

          <div
            className="rooms-slider"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{
              transform: `translateX(-${currentIndex * (100 / cardsPerView)}%)`,
            }}
          >
            {roomsData.map((room, i) => (
              <div
                className={`room-card ${
                  i >= currentIndex && i < currentIndex + cardsPerView
                    ? "active"
                    : "inactive"
                } ${tappedIndex === i ? "show-overlay" : ""}`}
                key={i}
                style={{ flex: `0 0 ${100 / cardsPerView}%` }}
                onClick={() => handleCardTap(i)}
              >
                <div className="room-image">
                  <img src={room.image} alt={room.type} />

                  <div className="room-overlay">
                    <h3>{room.type}</h3>
                    <p>{room.description}</p>
                    <Link to="/rooms">
                      <button className="room-btn" onClick={scrollToTop}>
                        View Details
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="room-info">
                  <h3>{room.type}</h3>
                  <p>{room.description}</p>
                </div>
              </div>
            ))}
          </div>

          {cardsPerView < 3 && (
            <FaArrowRight className="arrow right" onClick={next} />
          )}
        </div>
      </section>
      <section className="info-container">
        <div className="restaurant-container">
          <div className="rest-desc">
            <h3>FINE FOOD</h3>
            <h1>RESTAURANT</h1>
            <p>
              Taste carefully prepared food made with fresh ingredients in a
              comfortable and inviting space. Whether for a quiet meal or a
              shared moment, our restaurant welcomes you.
            </p>
          </div>
          <div className="rest-img">
            <img src={Rest} alt="restaurant description" />
          </div>
        </div>
        <div className="reception-container">
          <div className="rec-img">
            <img src={Rec} alt="reception description" />
          </div>
          <div className="rec-desc">
            <h3>HOTEL PROFESSIONAL</h3>
            <h1>RECEPTION</h1>
            <p>
              Our reception staff is always ready to welcome you with
              professionalism and warmth. Whether you need assistance,
              information, or guidance, we make sure your experience at the
              hotel is smooth and memorable.
            </p>
          </div>
        </div>
      </section>
      <section className="review-section">
        <h1>
          <span className="quote">"</span>
          WONDERFUL STAY AT KURTI HOTEL
          <span className="quote">"</span>
        </h1>

        {/* Three dots separator */}
        <div className="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Review text */}
        <p>
          "The experience at Kurti Hotel was unforgettable. The staff were
          extremely welcoming, the rooms were elegant and comfortable, and the
          seaside location made our stay absolutely perfect. Highly recommend!"
        </p>

        {/* Button */}
        <a
          href="https://www.google.com/search?q=kurti+hotel+reviews"
          target="_blank"
          rel="noopener noreferrer"
          className="review-btn"
          onClick={scrollToTop}
        >
          Read All Reviews
        </a>
      </section>
      <section className="get-in-touch">
        <div className="contact-container">
          <h2>GET IN TOUCH</h2>
          <p>Contact for all your needs</p>
          <Link to="/contact">
            <button onClick={scrollToTop}>Contact Us</button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
